import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_CONTEXTUAL_PROMOTION_BUTTONS_BANDIT_CONFIG = defineFcm('contextual_promotion_buttons_bandit_config')
	.asJson(
		createShapeNormalizer({
			type: 'record',
			shape: {
				type: 'array',
				shape: { type: 'number' },
			},
		}),
	)
	.withDefault({})
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: 'TBD',
		context: 'promotion page',
		description:
			'Used to configure the buttons amounts for the promote page, based on the variant coming from the contextual_promotion_buttons bandit',
		import: false,
		template: {
			v1: [10, 20, 30, 40],
			v2: [20, 40, 60],
			v3: [20, 30, 50, 60],
			v4: [10, 50],
			v5: [60, 70, 80],
		},
		deprecated: 'No references found. Safe to delete after 2026-09-01.',
	});
